<template>
    <div class="faq-item">
        <button type="button" :class="[{opened: isOpened}]" @click="toggleAnswer()">{{ question.question }}</button>
        <div class="answer" v-if="isOpened" v-html="question.answer"></div>
    </div>
</template>

<style lang="scss" scoped>
    .faq-item {
        margin-bottom: 16px;
    }

    button {
        width: 100%;
        -webkit-appearance: none;
        background: var(--color-gray-light);
        position: relative;
        padding: 14px 45px 14px 20px;
        text-align: left;
        border: 0;
        font-size: 1.2rem;

        &.opened:before {
            transform: translateY(-50%) rotate(180deg);
        }

        &:before {
            content: '\f107';
            position: absolute;
            height: 20px;
            width: 20px;
            font-family: FontAwesome;
            right: 10px;
            font-size: 20px;
            line-height: 1em;
            text-align: center;
            top: 50%;
            transform: translateY(-50%);
            transition: transform .2s;
        }
    }

    .answer {
        font-size: 1.1rem;
        padding: 16px 20px;
    }
</style>

<script>
    export default {
        props: {
            question: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                isOpened: false
            }
        },

        methods: {
            toggleAnswer() {
                return this.isOpened = !this.isOpened
            }
        }
    }
</script>
